import { render, staticRenderFns } from "./ProductSuggestionItem.vue?vue&type=template&id=f46ac64c&scoped=true"
import script from "./ProductSuggestionItem.vue?vue&type=script&lang=js"
export * from "./ProductSuggestionItem.vue?vue&type=script&lang=js"
import style0 from "./ProductSuggestionItem.vue?vue&type=style&index=0&id=f46ac64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46ac64c",
  null
  
)

export default component.exports